import { ISpidUser } from './constants/CustomTypes';
import { Identity, Monetization } from '@schibsted/account-sdk-browser';

const windowAny = window as any;
const windowWithSpid = window as any as {
  Identity?: typeof Identity,
  identity?: Identity,
  Monetization?: typeof Monetization,
  monetization?: Monetization,
  vgsAsyncInit?: () => void,
};

windowAny.loginPromise = windowAny.loginPromise || windowAny.$.Deferred();
export const loginPromise = windowAny.loginPromise;

const logoutDestination: { [key: string]: string; } = {
  aftenposten: `https://ap.no`,
  bt: "https://bt.no",
  aftenbladet: "https://aftenbladet.no",
  fvn: "https://fvn.no",
  "av-avis": "https://av-avis.no",
  bygdanytt: "https://bygdanytt.no/",
  e24dinepenger: "https://www.e24.no/",
  "l-a": "https://l-a.no/",
  lister24: "https://lister24.no/",
  strilen: "https://strilen.no/",
  vestnytt: "https://vestnytt.no/",
  vg: "https://www.vg.no/",
};

const getLogoutDestination = (): string => {
  const currentLocation = window.location.hostname;
  const toLocation = Object.keys(logoutDestination).find(key => {
    return currentLocation.includes(key);
  });
  return logoutDestination[toLocation] || window.location.href;
};

export function spid_sessionChange(data: any) {
  console.log('spid_sessionChange', data); // tslint:disable-line no-console
  console.log('spid_sessionChange', data.userStatus); // tslint:disable-line no-console
  if (data.userStatus !== "unknown" && !(data instanceof Error)) {
    $.ajax({
      headers: {
        'X-SNOLM-SPID-SIG': data.sig,
      },
      method: 'POST',
      timeout: 15000,
      url: "/wp-content/themes/minside/api/createSessionByOauthToken.php",
    }).done((res) => {
      console.log('loginResponse done', res); // tslint:disable-line no-console

      windowAny.loginPromise.resolve(data);
    }).fail((res) => {
      console.log('loginResponse fail', res, data); // tslint:disable-line no-console
      if (res.status === 403 && data.userStatus === "connected" || data.userStatus === 'notConnected') {
        windowAny.location = windowAny.loginURL;
      } else {
        windowAny.loginPromise.reject(data);
      }
    });
    if (data.result) {
      $("#loggedOutMenu").hide();
      $("#loggedInMenu").show();
      $("#greetingAnchor").attr("href", "/minside/");
      $(".greeting-text").html('<span class="hello">Hei, </span><span class="name">' + data.givenName + '</span>');
      $("#customerSPiD").attr("value", data.userId);
      $("#customerName").attr("value", (data.givenName + " " + data.familyName).trim());

      if (windowAny.sndPaywallSession && windowAny.sndPaywallSession.mock) {
        if (windowAny.sndPaywallSession.Auth && windowAny.sndPaywallSession.Auth.logout) {
          windowAny.sndPaywallSession.Auth.logout = async () => {
            try {
              await fetch(windowAny.wpLogoutUrl, {
                mode: 'no-cors',
              });
            } catch (e) {
              console.log("Could not terminate WP session: ", e); // tslint:disable-line no-console
            }

            try {
              await windowAny.identity.logout(getLogoutDestination());
            } catch (e) {
              console.log("Could not terminate Schibsted Account session: ", e); // tslint:disable-line no-console
            }
          };
        }
      }
    }

    const delaysMs: number[] = [0, 100, 200, 400, 800, 1600, 3200];
    let delayIndex = 0;
    function waitForSndPaywallSession() {
      if (windowAny.sndPaywallSession) {
        console.log('waitForSndPaywallSession(), delayIndex: ', delayIndex); // tslint:disable-line no-console
        const state = JSON.stringify({ redirectUri: window.location.href });
        const loginURI = windowAny.identity.loginUrl(state);
        const logoutURI = windowAny.identity.logoutUrl(getLogoutDestination());

        windowAny.sndPaywallSession.getLoginURI = () => loginURI;
        windowAny.sndPaywallSession.getLogoutURI = () => logoutURI;
        windowAny.sndPaywallSession.login = () => windowAny.identity.login({
          state: JSON.stringify({redirectUri: window.location.href}),
        });

        if (windowAny._coreHeader && windowAny._coreHeader.setSessionData) {
          windowAny._coreHeader.setSessionData(Object.assign({}, {
            loginURI,
            logoutURI,
          }, data.result ? {
            familyName: data.familyName,
            givenName: data.givenName,
            loggedIn: true,
            sig: data.sig,
            userId: data.userId,
          } : {}));
        }
      } else if (++delayIndex < delaysMs.length) {
        setTimeout(waitForSndPaywallSession, delaysMs[delayIndex]);
      }
    }
    setTimeout(waitForSndPaywallSession, delaysMs[delayIndex]);

    $(() => {
      if (typeof windowAny.redirect_minside !== "undefined") {
        windowAny.redirect_minside();
      }
      if (typeof windowAny.fill_faq !== "undefined") {
        windowAny.fill_faq(data);
      }
      if (typeof windowAny.loggedin_callback !== "undefined") {
        windowAny.loggedin_callback(data.userId);
      }
    });
  } else {
    windowAny.loginPromise.reject(data);
  }
}

export function checkLogin() {
  if (!windowWithSpid.identity) {
    windowWithSpid.identity = new Identity(windowAny.spidInitOpts);
    windowWithSpid.identity._enableSessionCaching = false;
  }
  if (!windowWithSpid.monetization) {
    windowWithSpid.monetization = new Monetization(windowAny.spidInitOpts);
  }
  windowWithSpid.identity.hasSession(false)
    .then(spid_sessionChange)
    .catch(spid_sessionChange);
}

export function initSpid() {
  if (windowAny.loginPromise.state() === 'resolved') {
    return;
  }
  console.log('initSpid(), window.sndPaywallSession: ', windowAny.sndPaywallSession); // tslint:disable-line no-console
  if (windowAny.sndPaywallSession) {
    console.log('initSpid(), window.sndPaywallSession.isSdkReady(): ', windowAny.sndPaywallSession.isSdkReady()); // tslint:disable-line no-console
    const delaysMs: number[] = [0, 100, 200, 400, 800, 1600, 3200];
    let delayIndex = 0;
    function callCheckLogin() {
      const id = windowAny.sndPaywallSession.identity;
      const events = id && id.e;
      if (windowAny.sndPaywallSession.isSdkReady() && events && events.sessionChange) {
        checkLogin();
      } else if (++delayIndex < delaysMs.length) {
        const delayMs = delaysMs[delayIndex];
        console.log('callCheckLogin(), waiting ' + delayMs + 'ms for core-header to initialize'); // tslint:disable-line no-console
        setTimeout(callCheckLogin, delayMs);
      } else {
        console.log('callCheckLogin(), gave up waiting core-header to initialize, doing Event.subscribe'); // tslint:disable-line no-console
        windowAny.sndPaywallSession.Event.subscribe('init', checkLogin);
      }
    }
    callCheckLogin();
  } else {
    windowWithSpid.identity = new Identity(windowAny.spidInitOpts);
    windowWithSpid.identity._enableSessionCaching = false;
    windowWithSpid.monetization = new Monetization(windowAny.spidInitOpts);
    // Trigger session check
    checkLogin();
  }
  if (!windowWithSpid.Identity) {
    windowWithSpid.Identity = Identity;
  }
  if (!windowWithSpid.Monetization) {
    windowWithSpid.Monetization = Monetization;
  }
  if (windowWithSpid.vgsAsyncInit) {
    windowWithSpid.vgsAsyncInit();
  }
}

export function getSession(): Promise<ISpidUser> {
  return new Promise((resolve, reject) => {
    const sessionCheck = () => {
      windowAny.identity.hasSession(false)
        .then(resolve)
        .catch(reject);
    };

    if (windowWithSpid.identity) {
      sessionCheck();
    } else {
      const interval = setInterval(() => {
        if (windowWithSpid.identity) {
          clearInterval(interval);
          sessionCheck();
        }
      }, 100);
    }
  });
}
